import { Injectable, signal } from '@angular/core';
import { IExamViewModel } from '../../../api/exam-view-model.model';
import { IQuestionCategories } from '../../shared/models/question-categories';
import { IExamQuestionAdminMetaVm } from '../../shared/models/exam-question-admin-meta-vm';

@Injectable({
  providedIn: 'root'
})
export class QuestionDatabaseDataService {

  public questionCategories = signal<IQuestionCategories[]>([]);
  public availableExams = signal<IExamViewModel[]>([]);
  public questionsList = signal<IExamQuestionAdminMetaVm[]>([]);
}
